import useBottomSheetStore from 'stores/bottomSheetStore';

/**
 * BottomSheet 커스텀 훅
 * 컴포넌트 내부에서 BottomSheet 상태를 관리할 때 사용
 */
const useBottomSheet = () => {
  const store = useBottomSheetStore();

  const getSheet = (id: string) => {
    return store.sheets[id];
  };

  return {
    open: store.open,
    close: store.close,
    closeWithAnimation: store.close,
    sheets: store.sheets,
    getSheet,
    setStatus: store.setStatus,
    updateOptions: store.updateOptions,
    updateData: store.updateData,
  };
};

export default useBottomSheet;
